import React from 'react';
import { Button } from 'react-bootstrap'; // Assuming you're using React-Bootstrap
import { Link } from 'react-router-dom';

const BackButton = ({ url, labelText }) => (
    <Button variant="secondary" as={Link} to={url}>
        {labelText}
    </Button>
);

export default BackButton;
